import styled from 'styled-components'
import { MAX_PAGE_WIDTH } from 'utils/constants'

export const Container = styled.main`
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  /* Altura real do header fixo, publicada por HeaderUI. O fallback só vale antes do primeiro
     layout effect; não replicar a altura aqui como número. */
  margin-top: var(--header-h, 120px);
  background-color: #fafafa;
`

export const Wrapper = styled.div`
  height: calc(100dvh - 74px);
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  @media (min-width: 768px) {
    height: calc(100dvh - 106px);
  }
`

interface PagesWrapperProps {
  applyMaxWidth: boolean
  fullHeight?: boolean
}

export const PagesWrapper = styled.div<PagesWrapperProps>`
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
  width: 100%;
  max-width: ${({ applyMaxWidth }) => (applyMaxWidth ? MAX_PAGE_WIDTH : '100%')};
`
